import type { Plate } from './plate.interface';

export interface cv_PlateStatus {
    Abbreviation: string;
    C_PlateStatus_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    Plate: Plate[];
    PlateStatus: string;
    SortOrder: number | null;
    Version: number;
}
